<template>
  <div id="delete-modal">
    <div class="text" v-html="text"></div>
    <div class="footer">
      <inline-link
        class="inline-link"
        :text="$t('deleteModal.cancelButton')"
        @inlineLinkClicked="closeModal"
      />
      <rounded-button
        width="150px"
        buttonType="danger"
        position="right"
        @click="deleteClicked"
      >
        <div v-html="$t('deleteModal.deleteButton')" />
      </rounded-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeleteModal",
  props: {
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    deleteClicked() {
      this.$emit("deleteClicked");
    },
    closeModal() {
      this.$eventBus.closeModal();
    }
  }
};
</script>
<style lang="scss" scoped>
#delete-modal {
  padding: 20px;
  padding-top: 10px !important;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  .text {
    text-align: center;
    line-height: 1.5;
    margin-bottom: 30px;
  }
  .footer {
    width: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
